import React from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { OrderDetailsFormWrapperValues } from "src/models/OrderDetailsFormWrapper.model";
import OrderDetailsForm from "./OrderDetailsForm";
import { useOutletContext, useParams } from "react-router-dom";
import { useUpdateOrderByIdMutation } from "src/services/OfflineOrderService";
import { showToast } from "src/utils/showToaster";

const OrderDetailsFormWrapper = () => {
  const { orderId } = useParams();
  const [offlineOrderData]: any = useOutletContext();
  const [updateOrder] = useUpdateOrderByIdMutation();
  // Form Initial Values
  const initialValues: OrderDetailsFormWrapperValues = {
    name: offlineOrderData?.name || "",
    email: offlineOrderData?.email || "",
    mobile: offlineOrderData?.mobile || "",
    userType: {
      label: offlineOrderData?.userType,
      value: offlineOrderData?.userType,
    },
    products: offlineOrderData?.products?.map((prod: any) => {
      return {
        productId: {
          label: prod.productName,
          value: prod.productId,
        },
        varientId: {
          label: prod.varientId,
          value: prod.varientId,
        },
        quantity: prod.quantity,
      };
    }),
    attemptDue: {
      label: offlineOrderData?.attemptName,
      value: offlineOrderData?.attemptId,
    },
    croNumber: offlineOrderData?.croNumber || "",
    courierCharges: offlineOrderData?.courierCharges || "",

    deliveryOption: {
      label: offlineOrderData?.delivery,
      value: offlineOrderData?.delivery,
    },

    remark: offlineOrderData?.remark || "",

    address: offlineOrderData?.address || "",
    pincode: offlineOrderData?.pincode || "",
    state: offlineOrderData?.state || "",
    city: offlineOrderData?.city || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    mobile: string().required("Please enter mobile number"),
    email: string()
      .email("Please enter valid email")
      .required("Please enter email"),
    address: string().test(
      "address-test",
      "Address required",
      (value, context) => {
        const { deliveryOption } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    city: string().test(
      "address-test",
      "City is required",
      (value, context) => {
        const { deliveryOption } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    state: string().test(
      "address-test",
      "State is required",
      (value, context) => {
        const { deliveryOption } = context.parent;
        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    pincode: string().test(
      "address-test",
      "Pincode is required",
      (value, context) => {
        const { deliveryOption } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    attemptDue: object().required("Please select attempt due"),
    croNumber: string().required("Please enter CRO number"),
    deliveryOption: object().required("Please select one delivery option"),
  });

  // Handle Submit
  const handleSubmit = (
    values: OrderDetailsFormWrapperValues,
    { setSubmitting, resetForm }: FormikHelpers<OrderDetailsFormWrapperValues>
  ) => {
    const formattedValues = {
      name: values?.name,
      email: values?.email,
    };

    updateOrder({ id: orderId, body: formattedValues }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
          <OrderDetailsForm formikProps={formikProps} />
        </Form>
      )}
    </Formik>
  );
};

export default OrderDetailsFormWrapper;
